import { useEffect, useState } from "react";

// Breakpoints shared by the layout shell, sheets and global styles
// (src/style/app.scss mirrors these values).
export const MOBILE_QUERY = "(max-width: 767.98px)";
export const COMPACT_QUERY = "(max-width: 1199.98px)";

const getMatch = (query) =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia(query).matches
    : false;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => getMatch(query));

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // Safari < 14 only supports addListener.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
};

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

export default useMediaQuery;
